module.exports = __webpack_public_path__ + "img/Button-kosik-2021-02.44f44be1.png";